import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { HardDrive, Loader2, ExternalLink } from "lucide-react";
import { api } from "../../lib/api";

let driveOn = null, inflight = null;
export function useDriveConnected() {
  const [on, setOn] = useState(driveOn);
  useEffect(() => {
    if (driveOn !== null) return undefined;
    let alive = true;
    inflight = inflight || api.get("/integrations/google/status").then((r) => { driveOn = !!r.data?.connected; return driveOn; }).catch(() => { driveOn = false; return false; });
    inflight.then((v) => { if (alive) setOn(v); });
    return () => { alive = false; };
  }, []);
  return on;
}

// "Simpan ke Drive" on a finished stage result (Docs, or Sheets when the result is a table). Shows the saved link afterwards.
export function StepDriveSave({ task, s, i, onDone }) {
  const on = useDriveConnected();
  const [busy, setBusy] = useState(false);
  if (!on) return null;
  const save = async (kind) => {
    setBusy(true);
    try { const r = await api.post(`/tasks/${task.id}/steps/${s.id}/drive`, { kind }); toast.success(`Tersimpan di Drive: ${r.data.name}`); onDone?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal menyimpan ke Drive"); } finally { setBusy(false); }
  };
  const hasTable = /\n\s*\|.*\|\s*\n\s*\|[-:| ]+\|/.test(s.output || "");
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs" data-testid={`wf-step-drive-${i}`}>
      <button type="button" disabled={busy} onClick={() => save("doc")} className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-2.5 py-1 font-semibold text-slate-600 hover:border-emerald-500 hover:text-emerald-600 disabled:opacity-60" data-testid={`wf-step-drive-doc-${i}`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <HardDrive size={12} />} Simpan ke Drive (Docs)
      </button>
      {hasTable && <button type="button" disabled={busy} onClick={() => save("sheet")} className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-2.5 py-1 font-semibold text-slate-600 hover:border-emerald-500 hover:text-emerald-600 disabled:opacity-60" data-testid={`wf-step-drive-sheet-${i}`}>
        <HardDrive size={12} /> Sebagai Sheets
      </button>}
      {s.drive?.link && <a href={s.drive.link} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-emerald-700 hover:underline" data-testid={`wf-step-drive-link-${i}`}><ExternalLink size={11} /> {s.drive.name}</a>}
    </div>
  );
}

// Export the whole workflow (goal + daftar isi + every finished stage) as one Google Doc. Visible when Drive is connected and ≥1 stage has output.
export function ExportDriveButton({ task, onDone }) {
  const on = useDriveConnected();
  const [busy, setBusy] = useState(false);
  const any = (task.steps || []).some((s) => (s.output || "").trim());
  if (!on || !any) return null;
  const run = async () => {
    setBusy(true);
    try { const r = await api.post(`/tasks/${task.id}/drive`); toast.success(`Google Doc dibuat: ${r.data.name}`); window.open(r.data.link, "_blank", "noopener"); onDone?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal mengekspor ke Drive"); } finally { setBusy(false); }
  };
  return (
    <span className="flex items-center gap-1.5">
      <button type="button" disabled={busy} onClick={run} className="flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-[11px] font-bold text-emerald-700 hover:bg-emerald-100 disabled:opacity-60" data-testid="wf-export-drive-btn">
        {busy ? <Loader2 size={12} className="animate-spin" /> : <HardDrive size={12} />} Ekspor ke Google Doc
      </button>
      {task.drive_export?.link && <a href={task.drive_export.link} target="_blank" rel="noreferrer" className="text-[11px] text-emerald-700 hover:underline" data-testid="wf-export-drive-link" title={task.drive_export.name}><ExternalLink size={11} /></a>}
    </span>
  );
}
